import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { Box, CircularProgress, Typography } from "@mui/material";
import type { FC } from "react";
import type { NurseData } from "../../../utils/models";
import { createDateRange, findDateIndex } from "../../../utils/nursePanelUtils";
import { NursesMatrixGrid } from "../../NursesMatrixGrid/NursesMatrixGrid";
import { NurseTableBox } from "../DialogUtils";
import type { UseSwapDataResult } from "./hooks/useSwapData";

interface SwapRequestTablesProps {
	nursesData: NurseData[];
	isFetching: boolean;
	swapData: UseSwapDataResult;
	contentOnly?: boolean;
}

export const SwapRequestTables: FC<SwapRequestTablesProps> = ({ nursesData, isFetching, swapData, contentOnly }) => {
	const targetDateRange = createDateRange(swapData.targetShiftDate);
	const targetDayIdx = findDateIndex(targetDateRange, swapData.targetShiftDate);
	const originDateRange = createDateRange(swapData.originShiftDate);
	const originDayIdx = findDateIndex(originDateRange, swapData.originShiftDate);

	const disabledNursesData = nursesData.map((nurse) => ({
		...nurse,
		selectable: false,
	}));

	if (isFetching) {
		return (
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<CircularProgress size={24} />
			</Box>
		);
	}
	return (
		<Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
			<NurseTableBox>
				<NursesMatrixGrid
					nursesData={disabledNursesData}
					dateRange={originDateRange}
					highlightDateIndexes={[originDayIdx]}
					isAdd={true}
					filterDate={swapData.originShiftDate}
					enableKeyboardNav={false}
				/>
			</NurseTableBox>
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", my: 2, rotate: "90deg", width: "fit-content" }}>
				<SwapHorizIcon sx={{ fontSize: 40, color: "primary.dark" }} />
			</Box>
			<Box>
				<Typography variant="h6" sx={{ fontWeight: 600, color: "primary.dark", mb: 1, fontSize: "18px", mt: contentOnly ? 0 : 2 }}>
					{`Target Shift - ${swapData.targetShiftDate.toFormat("ccc, LLL d")}`}
				</Typography>
				<NurseTableBox>
					<NursesMatrixGrid
						nursesData={swapData.targetNurseData}
						dateRange={targetDateRange}
						highlightDateIndexes={[targetDayIdx]}
						isAdd={true}
						filterDate={swapData.targetShiftDate}
						enableKeyboardNav={false}
					/>
				</NurseTableBox>
			</Box>
		</Box>
	);
};
